// Utility to sanitize and validate user input
// Blocks script tags and angle brackets (basic XSS protection)

export function sanitizeInput(input) {
    if (typeof input !== "string") return input;
    let sanitized = input.replace(/<script.*?>.*?<\/script>/gi, "");
    sanitized = sanitized.replace(/[<>]/g, "");
    return sanitized;
}

export function isInputSafe(input) {
    if (typeof input !== "string") return true;
    // Block script tags and angle brackets
    return !(/<script.*?>.*?<\/script>/gi.test(input) || /[<>]/.test(input));
} 